export const imageManifest = [
  "/assets/leftFlower.png",
  "/assets/rightFlower.png",
  "/assets/wedImg1.png",
  "/assets/wedImg2.jpeg",
  "/assets/wedImg3.png",
];
